<select class="input minimal" (change)="addIsAdminFilter($event)" [value]="SelectedIsAdmin">
    <!-- <option value="false" style="color:gray">Select User Type</option> -->
    <option value="false" style="color:gray">Users</option>
    <option value="true" style="color:gray">Administrators</option>
</select>